var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7503 15.8579H8.69056L7.146 9.79198C7.07269 9.51295 6.91703 9.26627 6.68806 9.15001C6.11664 8.85784 5.48696 8.62531 4.80005 8.50804V8.2745H8.11813C8.57607 8.2745 8.91953 8.62531 8.97677 9.03274L9.77817 13.4083L11.8369 8.2745H13.8394L10.7503 15.8579ZM14.9843 15.8579H13.039L14.6408 8.2745H16.5861L14.9843 15.8579ZM19.1028 10.3753C19.16 9.96689 19.5035 9.73335 19.9042 9.73335C20.5338 9.67471 21.2197 9.79199 21.7922 10.0832L22.1356 8.45042C21.5632 8.21688 20.9335 8.09961 20.3621 8.09961C18.4741 8.09961 17.1003 9.15002 17.1003 10.6078C17.1003 11.7169 18.0734 12.2992 18.7603 12.65C19.5035 12.9998 19.7897 13.2334 19.7324 13.5832C19.7324 14.1079 19.16 14.3414 18.5886 14.3414C17.9017 14.3414 17.2147 14.1665 16.5861 13.8743L16.2426 15.5081C16.9295 15.7992 17.6727 15.9165 18.3596 15.9165C20.4766 15.9741 21.7922 14.9247 21.7922 13.3496C21.7922 11.3661 19.1028 11.2498 19.1028 10.3753ZM28.6 15.8579L27.0555 8.2745H25.3965C25.053 8.2745 24.7095 8.50804 24.5951 8.85784L21.7349 15.8579H23.7374L24.1371 14.7498H26.5976L26.8265 15.8579H28.6ZM25.6827 10.3167L26.2541 13.1747H24.6523L25.6827 10.3167Z",
    fill: "#172B85"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F2F4F7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "edf93f121a1ec14d6f8f26d7b751108e.svg";
export { ForwardRef as ReactComponent };